import { createFileRoute } from '@tanstack/react-router'
import { ApiKeysPage } from '../../components/ApiKeys'

export const Route = createFileRoute('/dev/api-keys')({
  component: ApiKeysPage,
})
